module.exports = __webpack_public_path__ + "img/kitty-sleep.8c1e47f7.jpg";